module.exports = __webpack_public_path__ + "img/iys-main.b92464b3.svg";